import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-csrproject-detailspage',
  templateUrl: './csrproject-detailspage.component.html',
  styleUrls: ['./csrproject-detailspage.component.css'],
})
export class CsrprojectDetailspageComponent implements OnInit {
  private getApi = environment.url + environment.csrProjectGet;
  private getIntrest = environment.url + environment.csrIntrestProject;

  showModal: boolean = false;
  modalContent: string = '';
  modalText: string = '';
  /**
   * Constructs an instance of the CsrprojectDetailspageComponent.
   * @param route The ActivatedRoute service is used to access the route parameters.
   * @param router The Router service is used to navigate to different routes.
   * @param makeapi The ApiService is used to make API calls.
   * @param getdata The ValueService is used to get application state.
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private makeapi: ApiService,
    private getdata: ValueService
  ) {}
  imageUrl;
  incorpdownloadUrl;
  tweldocumentUrl;
  actiondocumentUrl;
  trckrecdocumentUrl;
  otherrecdocumentUrl;
  /**
   * Called when the component is initialized.
   * Subscribes to the route query parameters to get the ID of the CSR project.
   * Calls the `viewCSRProjectGet` method to get the CSR project details.
   */
  ngOnInit(): void {
    // Show the loading indicator
    this.getdata.isVisibleSource.next(true);

    // Subscribe to the route query parameters to get the ID of the CSR project
    this.route.queryParams
      .pipe(filter((params) => params._id))
      .subscribe((params) => {
        // Call the `viewCSRProjectGet` method to get the CSR project details
        this.viewCSRProjectGet(atob(params._id));
      });

    // Call the `projectView` method to get the CSR project view
    this.projectView();
  }

  projectView: any = [];
  /**
   * Makes an API call to get the CSR project details by ID.
   * The response of the API call is stored in the component's
   * `projectView` property.
   * @param id The ID of the CSR project to get the details of.
   */
  viewCSRProjectGet(id) {
    // Show the loading indicator
    this.getdata.amizhthLoader('show');
    // Make the API call
    this.makeapi
      .method(this.getApi + 'id=' + id, '', 'get')
      .subscribe((data) => {
        // Hide the loading indicator
        this.getdata.amizhthLoader('hide');
        // Store the response in the component's `projectView` property
        this.projectView = data;
        // Store the document URLs in separate properties
        this.incorpdownloadUrl =
          this.projectView.incorpCertifDocuments.documentName;
        this.tweldocumentUrl = this.projectView.twlaa80gDocuments.documentName;
        this.actiondocumentUrl =
          this.projectView.actionPlanDocuments.documentName;
        this.trckrecdocumentUrl =
          this.projectView.trackRecordDocuments.documentName;
        this.otherrecdocumentUrl = this.projectView.otherDocuments.documentName;
      });
  }

  /**
   * Opens the incorporation document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  incorpDocu() {
    if (this.incorpdownloadUrl) {
      // Open the file URL in a new browser tab
      window.open(this.incorpdownloadUrl, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the action document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  actionDocu() {
    if (this.actiondocumentUrl) {
      // Open the file URL in a new browser tab
      window.open(this.actiondocumentUrl, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the Twlaa80g document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  twlaa80gDoc() {
    if (this.tweldocumentUrl) {
      // Open the file URL in a new browser tab
      window.open(this.tweldocumentUrl, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the track record document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  trackrecDoc() {
    if (this.trckrecdocumentUrl) {
      // Open the file URL in a new browser tab
      window.open(this.trckrecdocumentUrl, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Opens the other relevant document file in a new tab if available.
   * Logs an error message to the console if the file is not available.
   */
  otherrecDoc() {
    if (this.otherrecdocumentUrl) {
      // Open the file URL in a new browser tab
      window.open(this.otherrecdocumentUrl, '_blank');
    } else {
      // Log an error message if the file URL is not available
      console.error('Download URL is not available.');
    }
  }
  /**
   * Handles the 'Back' button click event.
   * Navigates back to the list of available CSR projects.
   */
  backBtn(): void {
    this.router.navigateByUrl('/csrsavailproject');
  }

  msgdata;
  msgdata2;
  /**
   * Handles the 'I'm Interested' button click event.
   * Fetches interest data for a given project ID and displays a success or notified modal based on the response.
   * @param id - The project ID for which the interest is being shown.
   */
  intrestbtn(id: string): void {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to register interest for the project
    this.makeapi
      .method(this.getIntrest + 'id=' + id, '', 'get')
      .subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');

        // Check response status and show appropriate modal
        if (data.responseStatus == 'Success') {
          // Display success modal if the interest registration was successful
          document.getElementById('interestSuccess').style.display = 'block';
        } else {
          // Display notified modal if the interest was already registered
          document.getElementById('interestNotified').style.display = 'block';
        }
      });
  }
  /**
   * Closes the 'interest success' modal.
   * Hides the modal by setting its display property to 'none'.
   */
  closeModalInterestSuccess(): void {
    document.getElementById('interestSuccess').style.display = 'none'; // Hide the modal
  }
  /**
   * Closes the 'interest notified' modal.
   * Hides the modal by setting its display property to 'none'.
   */
  closeModalInterestNotified(): void {
    document.getElementById('interestNotified').style.display = 'none'; // Hide the modal
  }
}
